export const groupTypes = {
  PUBLIC: "public",
  PRIVATE: "private",
  MANDATORY: "mandatory",
  SECRET: "secret",
  COURSE: "course"
}
